import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import clsModals from '../modals.module.scss';
import modalActions from '../../../redux/actions/modals';

function Confirm({ action, closeAction, modalName }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const closeModal = () => {
    if (closeAction) {
      closeAction();
    } else {
      dispatch(modalActions.closeModal(modalName));
    }
  };

  const handleConfirm = (e) => {
    action(e);
    closeModal();
  };

  return (
    <div>
      <div className={clsModals.event_popup_buttons}>
        <Button variant="outlined" color="primary" onClick={handleConfirm}>
          {t('create.step3.yes')}
        </Button>
        <Button variant="outlined" onClick={closeModal}>
          {t('create.step3.no')}
        </Button>
      </div>
    </div>
  );
}

export default Confirm;
